(() => {
  const marker = 'selection-v1';
  const isGift = item => item.properties?._wntn_gift_test === marker;
  const hasPaidProduct = (cart, config) => cart.items.some(item => !isGift(item) && !config.giftIds.includes(item.variant_id) && config.regularIds.includes(item.variant_id) && item.quantity > 0 && item.final_line_price > 0);
  function checkCart(cart, config) {
    const gifts = cart.items.filter(isGift);
    if (!gifts.length) return null;
    if (gifts.length !== 1 || gifts[0].quantity !== 1 || !config.giftIds.includes(gifts[0].variant_id)) return 'Bitte wähle genau eine Gratisflasche aus.';
    if (!hasPaidProduct(cart, config)) return 'Bitte lege zuerst ein reguläres kostenpflichtiges Produkt in den Warenkorb. Die Gratisflasche ist eine Zugabe zu deiner Bestellung.';
    if (!config.personalCustomer && gifts[0].final_line_price !== 0) return 'Dein persönlicher Code wurde nicht angewendet. Bitte wähle die Gratisflasche erneut oder entferne die Gratisflasche.';
    return null;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {isGift, checkCart, hasPaidProduct}; return; }
  const config = window.WNTNGiftTest;
  if (!config) return;
  // Personal code is handed over in a URL fragment, never embedded in public theme assets.
  const grantKey = 'wntn-gift-grant';
  const validGrant = grant => grant && /^WNTN-[A-Z0-9-]{12,80}$/.test(grant.code) && Number.isFinite(Date.parse(grant.endsAt)) && Date.parse(grant.endsAt) > Date.now();
  let grant;
  try {
    if (location.hash.startsWith('#wntn-gift=')) {
      grant = JSON.parse(decodeURIComponent(location.hash.slice(11)));
      history.replaceState(null, '', location.pathname + location.search);
      if (validGrant(grant)) sessionStorage.setItem(grantKey, JSON.stringify(grant));
      else sessionStorage.removeItem(grantKey);
    } else grant = JSON.parse(sessionStorage.getItem(grantKey) || 'null');
  } catch { sessionStorage.removeItem(grantKey); }
  if (!validGrant(grant)) return;
  Object.assign(config, grant);
  sessionStorage.setItem('wntn-gift-test-entry', '1');
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let checkoutAllowed = false;
  let changingGift = false;
  const status = () => document.querySelector('[data-gift-inline]:not([hidden]) [data-gift-inline-status]') || document.getElementById('gift-test-status');
  function message(text, error = false) {
    let node = status();
    if (!node) {
      node = document.getElementById('gift-test-checkout-message');
      if (!node) { node = document.createElement('div'); node.id = 'gift-test-checkout-message'; node.className = 'gift-test-checkout-message'; node.setAttribute('role', 'alert'); document.body.append(node); }
    }
    node.textContent = text; node.dataset.error = String(error);
  }
  async function api(path, body) {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Content-Type':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {}), cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Der Shop konnte die Änderung nicht speichern. Bitte erneut versuchen.');
    return data;
  }
  async function removeGifts() {
    // Always reread keys: Shopify changes line keys when discounts change.
    for (let count = 0; count < 20; count++) {
      const cart = await api('cart.js');
      const line = cart.items.find(isGift);
      if (!line) return cart;
      await api('cart/change.js', {id:line.key, quantity:0});
    }
    throw new Error('Die Gratisflaschen konnten nicht vollständig entfernt werden.');
  }
  async function select(variant) {
    if (!config.giftIds.includes(variant)) throw new Error('Diese Flasche ist nicht als Gratisflasche verfügbar.');
    if (!validGrant(config)) throw new Error('Deine Gratisflasche ist abgelaufen.');
    let cart = await api('cart.js');
    if (!hasPaidProduct(cart, config)) throw new Error('Bitte lege zuerst ein reguläres kostenpflichtiges Produkt in den Warenkorb.');
    if (!sessionStorage.getItem('wntn-gift-test-discounts')) sessionStorage.setItem('wntn-gift-test-discounts', JSON.stringify((cart.discount_codes || []).map(d => d.code).filter(c => c !== config.code)));
    const existing = cart.items.filter(isGift);
    if (!(existing.length === 1 && existing[0].variant_id === variant && existing[0].quantity === 1)) {
      await removeGifts();
      await api('cart/add.js', {items:[{id:variant, quantity:1, properties:{_wntn_gift_test:marker, _deposit_units:'1'}}]});
    }
    const previous = JSON.parse(sessionStorage.getItem('wntn-gift-test-discounts') || '[]');
    cart = await api('cart/update.js', {discount:[...previous,config.code].join(',')});
    const chosen = cart.items.filter(isGift);
    if (chosen.length !== 1 || chosen[0].quantity !== 1 || chosen[0].variant_id !== variant || (!config.personalCustomer && chosen[0].final_line_price !== 0)) throw new Error('Die Gratisflasche ist noch nicht korrekt rabattiert. Bitte erneut wählen; vorhandene Zugaben werden dabei ersetzt.');
    if (typeof window.updateDeposit === 'function') await window.updateDeposit();
    if (document.querySelector('cart-drawer.active')) {
      sessionStorage.setItem('wntn-gift-reopen-drawer', '1');
      location.reload();
    } else location.assign(root + 'cart');
  }
  if (document.querySelector('.gift-test')) sessionStorage.setItem('wntn-gift-test-entry', '1');
  let refreshTimer;
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshEligibility, 350); }
  async function refreshEligibility() {
    if (busy) { scheduleRefresh(); return; }
    busy = true;
    try {
      const cart = await api('cart.js');
      const eligible = hasPaidProduct(cart, config);
      const gifts = cart.items.filter(isGift);
      if (!eligible && gifts.length) {
        await removeGifts();
        if (typeof window.updateDeposit === 'function') await window.updateDeposit();
        sessionStorage.setItem('wntn-gift-removed', '1');
        location.reload();
        return;
      }
      const selection = document.querySelector('[data-gift-options]');
      if (selection) selection.hidden = !eligible;
      const prerequisite = document.querySelector('[data-gift-prerequisite]');
      if (prerequisite) prerequisite.hidden = eligible;
      const entered = sessionStorage.getItem('wntn-gift-test-entry') || gifts.length;
      const showOptions = Boolean(validGrant(config) && entered && eligible && (!gifts.length || changingGift));
      for (const host of document.querySelectorAll('cart-items, cart-drawer .drawer__inner')) {
        let panel = host.querySelector('[data-gift-inline]');
        const upsell = host.querySelector('[data-wntn-cart-upsell]');
        if (!panel && showOptions) {
          const template = document.getElementById('gift-inline-template');
          if (template) {
            panel = template.content.firstElementChild.cloneNode(true);
            const anchor = upsell || host.querySelector('.drawer__footer');
            if (anchor) anchor.before(panel); else host.append(panel);
          }
        }
        if (panel) {
          panel.hidden = !showOptions;
          panel.querySelector('[data-gift-cancel]').hidden = !gifts.length;
        }
        if (upsell) upsell.hidden = showOptions;
      }
      if (sessionStorage.getItem('wntn-gift-removed')) {
        message('Die Gratisflasche wurde entfernt, weil kein kostenpflichtiges Produkt mehr im Warenkorb liegt.');
        sessionStorage.removeItem('wntn-gift-removed');
      }
    } catch (error) {
      const selection = document.querySelector('[data-gift-options]');
      if (selection) selection.hidden = true;
      document.querySelectorAll('[data-gift-inline]').forEach(panel => { panel.hidden = true; });
      document.querySelectorAll('[data-wntn-cart-upsell]').forEach(panel => { panel.hidden = false; });
      message(error.message || 'Der Warenkorb konnte nicht geprüft werden.', true);
    } finally { busy = false; }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  document.addEventListener('cart:updated', scheduleRefresh);
  window.addEventListener('pageshow', scheduleRefresh);
  const cartObserver = new MutationObserver(scheduleRefresh);
  for (const target of document.querySelectorAll('cart-items, cart-drawer')) cartObserver.observe(target, {childList:true,subtree:true});
  scheduleRefresh();
  if (sessionStorage.getItem('wntn-gift-reopen-drawer')) {
    sessionStorage.removeItem('wntn-gift-reopen-drawer');
    document.getElementById('cart-icon-bubble')?.click();
  }
  document.addEventListener('click', async event => {
    const scroll = event.target.closest('[data-gift-scroll]');
    if (scroll) {
      event.preventDefault();
      const list = scroll.closest('[data-gift-inline]').querySelector('.wntn-cart-upsell__list');
      const card = list.querySelector('.wntn-cart-upsell__item');
      list.scrollBy({left: Number(scroll.dataset.giftScroll) * ((card?.getBoundingClientRect().width || list.clientWidth) + 10), behavior:'smooth'});
      return;
    }
    const change = event.target.closest('.gift-test-label a');
    const cancel = event.target.closest('[data-gift-cancel]');
    if (change || cancel) {
      event.preventDefault();
      changingGift = Boolean(change);
      await refreshEligibility();
      const panel = document.querySelector('[data-gift-inline]:not([hidden])');
      if (panel) { panel.scrollIntoView({block:'nearest'}); panel.querySelector('button:not([disabled])')?.focus(); }
      return;
    }
    const choice = event.target.closest('[data-gift-select]');
    const remove = event.target.closest('[data-gift-remove]');
    if (!choice && !remove) return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    document.querySelectorAll('[data-gift-select],[data-gift-remove]').forEach(button => { button.disabled = true; });
    message('Deine Auswahl wird gespeichert …');
    try {
      if (choice) await select(Number(choice.dataset.giftSelect));
      else {
        await removeGifts();
        await api('cart/update.js', {discount:JSON.parse(sessionStorage.getItem('wntn-gift-test-discounts') || '[]').join(',')});
        sessionStorage.removeItem('wntn-gift-test-discounts');
        if (typeof window.updateDeposit === 'function') await window.updateDeposit();
        location.assign(root + 'cart');
      }
    } catch (error) { message(error.message || 'Die Änderung konnte nicht gespeichert werden.', true); }
    finally { busy = false; document.querySelectorAll('[data-gift-select],[data-gift-remove]').forEach(button => { button.disabled = button.dataset.giftUnavailable === 'true'; }); }
  });
  // Preview-only UX guard. It is intentionally not a substitute for server-side eligibility validation.
  async function guard(event, control) {
    if (checkoutAllowed) return;
    if (!document.querySelector('.gift-test-row')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    try {
      const cart = await api('cart.js');
      const problem = checkCart(cart, config);
      if (problem) { message(problem, true); return; }
      checkoutAllowed = true;
      control.click();
      checkoutAllowed = false;
    } catch (error) { message(error.message || 'Der Warenkorb konnte nicht geprüft werden.', true); }
    finally { busy = false; }
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[name="checkout"],#checkout,#CartDrawer-Checkout,a[href="/checkout"]');
    if (control) void guard(event, control);
  }, true);
})();
